class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'toggle',
      this.onToggle.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');

    const summary = this.mainDetailsToggle.querySelector('summary');

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;

    const summary =
      this.mainDetailsToggle.querySelector(':scope > summary');

    const submenu =
      this.mainDetailsToggle.querySelector(':scope > .header__submenu');

    /* OPEN when hovering Packages */
    summary.addEventListener('mouseenter', () => {
      if (window.innerWidth < 990) return;

      clearTimeout(this.closeTimer);

      this.mainDetailsToggle.open = true;
      summary.setAttribute('aria-expanded', 'true');
    });

    /* Start closing when leaving Packages */
    summary.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;

      this.scheduleClose(summary, submenu);
    });

    /* Keep open when entering dropdown */
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        if (window.innerWidth < 990) return;

        clearTimeout(this.closeTimer);
      });

      /* Close after leaving dropdown */
      submenu.addEventListener('mouseleave', () => {
        if (window.innerWidth < 990) return;

        this.scheduleClose(summary, submenu);
      });
    }
  }

  scheduleClose(summary, submenu) {
    clearTimeout(this.closeTimer);

    this.closeTimer = setTimeout(() => {

      const summaryHovered = summary.matches(':hover');
      const submenuHovered = submenu && submenu.matches(':hover');

      /*
       * Only close if mouse is outside BOTH
       * Packages and the dropdown.
       */
      if (!summaryHovered && !submenuHovered) {
        this.mainDetailsToggle.open = false;
        summary.setAttribute('aria-expanded', 'false');
      }

    }, 250);
  }

  onFocusOut() {
    if (window.innerWidth >= 990) return;

    super.onFocusOut();
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    ) {
      return;
    }

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);